/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The ManagerControllerDtoManagerViewResponse model module.
 * @module model/ManagerControllerDtoManagerViewResponse
 * @version 1.0
 */
class ManagerControllerDtoManagerViewResponse {
    /**
     * Constructs a new <code>ManagerControllerDtoManagerViewResponse</code>.
     * @alias module:model/ManagerControllerDtoManagerViewResponse
     */
    constructor() { 
        
        ManagerControllerDtoManagerViewResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ManagerControllerDtoManagerViewResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerControllerDtoManagerViewResponse} obj Optional instance to populate.
     * @return {module:model/ManagerControllerDtoManagerViewResponse} The populated <code>ManagerControllerDtoManagerViewResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerControllerDtoManagerViewResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('managerNo')) {
                obj['managerNo'] = ApiClient.convertToType(data['managerNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('secede')) {
                obj['secede'] = ApiClient.convertToType(data['secede'], 'Boolean');
            }
            if (data.hasOwnProperty('twoFactor')) {
                obj['twoFactor'] = ApiClient.convertToType(data['twoFactor'], 'Boolean');
            }
            if (data.hasOwnProperty('departmentNo')) {
                obj['departmentNo'] = ApiClient.convertToType(data['departmentNo'], 'Number');
            }
            if (data.hasOwnProperty('groupNo')) {
                obj['groupNo'] = ApiClient.convertToType(data['groupNo'], 'Number');
            }
            if (data.hasOwnProperty('loginIp')) {
                obj['loginIp'] = ApiClient.convertToType(data['loginIp'], 'Blob');
            }
            if (data.hasOwnProperty('loginAt')) {
                obj['loginAt'] = ApiClient.convertToType(data['loginAt'], 'Date');
            }
            if (data.hasOwnProperty('createdIp')) {
                obj['createdIp'] = ApiClient.convertToType(data['createdIp'], 'Blob');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('departmentName')) {
                obj['departmentName'] = ApiClient.convertToType(data['departmentName'], 'String');
            }
            if (data.hasOwnProperty('groupName')) {
                obj['groupName'] = ApiClient.convertToType(data['groupName'], 'String');
            }
            if (data.hasOwnProperty('connected')) {
                obj['connected'] = ApiClient.convertToType(data['connected'], 'Boolean');
            }
            if (data.hasOwnProperty('conIp')) {
                obj['conIp'] = ApiClient.convertToType(data['conIp'], 'Blob');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerControllerDtoManagerViewResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerControllerDtoManagerViewResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['departmentName'] && !(typeof data['departmentName'] === 'string' || data['departmentName'] instanceof String)) {
            throw new Error("Expected the field `departmentName` to be a primitive type in the JSON string but got " + data['departmentName']);
        }
        // ensure the json data is a string
        if (data['groupName'] && !(typeof data['groupName'] === 'string' || data['groupName'] instanceof String)) {
            throw new Error("Expected the field `groupName` to be a primitive type in the JSON string but got " + data['groupName']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
ManagerControllerDtoManagerViewResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
ManagerControllerDtoManagerViewResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
ManagerControllerDtoManagerViewResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
ManagerControllerDtoManagerViewResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
ManagerControllerDtoManagerViewResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} managerNo
 */
ManagerControllerDtoManagerViewResponse.prototype['managerNo'] = undefined;

/**
 * @member {String} email
 */
ManagerControllerDtoManagerViewResponse.prototype['email'] = undefined;

/**
 * @member {String} name
 */
ManagerControllerDtoManagerViewResponse.prototype['name'] = undefined;

/**
 * @member {Boolean} enabled
 */
ManagerControllerDtoManagerViewResponse.prototype['enabled'] = undefined;

/**
 * @member {Boolean} secede
 */
ManagerControllerDtoManagerViewResponse.prototype['secede'] = undefined;

/**
 * @member {Boolean} twoFactor
 */
ManagerControllerDtoManagerViewResponse.prototype['twoFactor'] = undefined;

/**
 * @member {Number} departmentNo
 */
ManagerControllerDtoManagerViewResponse.prototype['departmentNo'] = undefined;

/**
 * @member {Number} groupNo
 */
ManagerControllerDtoManagerViewResponse.prototype['groupNo'] = undefined;

/**
 * @member {Blob} loginIp
 */
ManagerControllerDtoManagerViewResponse.prototype['loginIp'] = undefined;

/**
 * @member {Date} loginAt
 */
ManagerControllerDtoManagerViewResponse.prototype['loginAt'] = undefined;

/**
 * @member {Blob} createdIp
 */
ManagerControllerDtoManagerViewResponse.prototype['createdIp'] = undefined;

/**
 * @member {Date} createdAt
 */
ManagerControllerDtoManagerViewResponse.prototype['createdAt'] = undefined;

/**
 * @member {String} departmentName
 */
ManagerControllerDtoManagerViewResponse.prototype['departmentName'] = undefined;

/**
 * @member {String} groupName
 */
ManagerControllerDtoManagerViewResponse.prototype['groupName'] = undefined;

/**
 * @member {Boolean} connected
 */
ManagerControllerDtoManagerViewResponse.prototype['connected'] = undefined;

/**
 * @member {Blob} conIp
 */
ManagerControllerDtoManagerViewResponse.prototype['conIp'] = undefined;






export default ManagerControllerDtoManagerViewResponse;

